(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["qn-compare-card"] && !Shopify.designMode) return;
  try {
    
  /* One custom element per concept, each re-initialising on
     connectedCallback so the theme editor re-injecting the DOM cannot leave
     a dead card behind. The _wired flag stops double wiring. */
  if (!customElements.get('qn-cc-card')) {
    customElements.define(
      'qn-cc-card',
      class QnCcCard extends HTMLElement {
        connectedCallback() {
          if (this._wired) return;
          this._wired = true;

          var section = this.closest('.qn-cc');
          var motion = section ? section.getAttribute('data-motion') : null;
          var reduced =
            window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          if (!motion || motion === 'none' || reduced || !('IntersectionObserver' in window)) {
            return;
          }

          this.classList.add('qn-cc__card--armed');

          var self = this;
          var reveal = function () {
            self.classList.add('qn-cc__card--in');
          };

          this._observer = new IntersectionObserver(
            function (entries, observer) {
              entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                reveal();
                observer.disconnect();
              });
            },
            { threshold: 0.01, rootMargin: '0px 0px -8% 0px' }
          );
          this._observer.observe(this);

          /* Safety net: a card that never intersects (collapsed editor
             preview, hidden tab) must not stay invisible. */
          this._fallback = window.setTimeout(reveal, 1600);
        }

        disconnectedCallback() {
          if (this._observer) this._observer.disconnect();
          if (this._fallback) window.clearTimeout(this._fallback);
          this._wired = false;
        }
      }
    );
  }

  if (!customElements.get('qn-cc-video')) {
    customElements.define(
      'qn-cc-video',
      class QnCcVideo extends HTMLElement {
        connectedCallback() {
          if (this._wired) return;
          this._wired = true;

          this._onClick = function (event) {
            var trigger = event.target.closest('[data-qn-cc-play]');
            if (!trigger) return;

            var src = this.getAttribute('data-embed');
            if (!src) return;

            var iframe = document.createElement('iframe');
            iframe.setAttribute('src', src);
            iframe.setAttribute('title', this.getAttribute('data-embed-title') || 'Video');
            iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('loading', 'lazy');

            this.innerHTML = '';
            this.appendChild(iframe);
          }.bind(this);

          this.addEventListener('click', this._onClick);
        }

        disconnectedCallback() {
          if (this._onClick) this.removeEventListener('click', this._onClick);
          this._wired = false;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qn-faq-split"] && !Shopify.designMode) return;
  try {
    
  // Exclusive-accordion polyfill + theme-editor block reveal.
  // Native <details name="..."> already handles exclusivity where supported;
  // this only fills the gap for older browsers.
  if (!customElements.get('qn-fq-list')) {
    class QnFqList extends HTMLElement {
      connectedCallback() {
        if (!this._wired) {
          this._wired = true;
          this._onToggle = this._onToggle.bind(this);
          this._onBlockSelect = this._onBlockSelect.bind(this);
          // `toggle` does not bubble, so listen in the capture phase.
          this.addEventListener('toggle', this._onToggle, true);
        }

        document.addEventListener('shopify:block:select', this._onBlockSelect);
      }

      disconnectedCallback() {
        if (this._onBlockSelect) {
          document.removeEventListener('shopify:block:select', this._onBlockSelect);
        }
      }

      get isExclusive() {
        return this.dataset.exclusive === 'true';
      }

      get hasNativeExclusive() {
        return (
          typeof HTMLDetailsElement !== 'undefined' && 'name' in HTMLDetailsElement.prototype
        );
      }

      _onToggle(event) {
        const row = event.target;

        if (!row || row.tagName !== 'DETAILS' || !row.open) return;
        if (!this.isExclusive || this.hasNativeExclusive) return;

        this.querySelectorAll('details[data-qn-fq-row]').forEach((other) => {
          if (other !== row && other.open) other.open = false;
        });
      }

      _onBlockSelect(event) {
        const target = event.target;

        if (!target || typeof target.closest !== 'function') return;
        if (!this.contains(target)) return;

        const row = target.matches('details[data-qn-fq-row]')
          ? target
          : target.closest('details[data-qn-fq-row]');

        if (row) row.open = true;
      }
    }

    customElements.define('qn-fq-list', QnFqList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qn-how-to-use"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // No custom-element support: reveal every pending step directly. Returning
    // early without this would leave them at opacity 0 forever — scripting IS
    // enabled here, so the @media (scripting: none) fallback never applies.
    if (typeof customElements === 'undefined') {
      var revealLegacy = function () {
        var nodes = document.querySelectorAll('.qn-ht__step[data-reveal="pending"]');
        for (var i = 0; i < nodes.length; i++) {
          nodes[i].setAttribute('data-reveal', 'in');
        }
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', revealLegacy);
      } else {
        revealLegacy();
      }
      return;
    }

    if (customElements.get('qn-ht-steps')) return;

    var FAILSAFE_MS = 2600;

    class QnHtSteps extends HTMLElement {
      connectedCallback() {
        // Guard against double-wiring while connected; the flag is cleared on
        // disconnect so the theme editor re-injecting the DOM re-initialises.
        if (this._wired) return;
        this._wired = true;
        try {
          this._init();
        } catch (error) {
          this._revealAll();
        }
      }

      disconnectedCallback() {
        this._teardown();
        this._wired = false;
      }

      _steps() {
        return Array.prototype.slice.call(this.querySelectorAll('.qn-ht__step[data-reveal]'));
      }

      _reveal(el) {
        el.setAttribute('data-reveal', 'in');
        if (this._observer) this._observer.unobserve(el);
      }

      _revealAll() {
        var self = this;
        this._steps().forEach(function (el) {
          self._reveal(el);
        });
      }

      _teardown() {
        if (this._observer) {
          this._observer.disconnect();
          this._observer = null;
        }
        if (this._failsafe) {
          clearTimeout(this._failsafe);
          this._failsafe = null;
        }
      }

      _init() {
        this._teardown();

        if (this.getAttribute('data-motion') === 'none') {
          this._revealAll();
          return;
        }

        var prefersReduced =
          typeof window.matchMedia === 'function' &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (prefersReduced || !('IntersectionObserver' in window)) {
          this._revealAll();
          return;
        }

        var stagger = parseInt(this.getAttribute('data-stagger') || '0', 10);
        if (isNaN(stagger) || stagger < 0) stagger = 0;

        var self = this;

        this._observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              var el = entry.target;
              var index = parseInt(el.getAttribute('data-index') || '0', 10);
              if (isNaN(index)) index = 0;
              el.style.setProperty('--qn-ht-delay', index * stagger + 'ms');
              self._reveal(el);
            });
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
        );

        var pending = this._steps().filter(function (el) {
          return el.getAttribute('data-reveal') === 'pending';
        });

        pending.forEach(function (el) {
          self._observer.observe(el);
        });

        // Failsafe: if the observer never fires, reveal anything already on
        // screen rather than leaving it invisible. Off-screen steps keep their
        // reveal so the effect still plays on scroll.
        this._failsafe = setTimeout(function () {
          self._steps().forEach(function (el) {
            if (el.getAttribute('data-reveal') !== 'pending') return;
            var rect = el.getBoundingClientRect();
            var inViewY = rect.top < (window.innerHeight || 0) && rect.bottom > 0;
            var inViewX = rect.left < (window.innerWidth || 0) && rect.right > 0;
            if (inViewY && inViewX) self._reveal(el);
          });
        }, FAILSAFE_MS);
      }
    }

    customElements.define('qn-ht-steps', QnHtSteps);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qn-video-wall"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('qn-video-wall')) {
    window.customElements.define(
      'qn-video-wall',
      class QnVideoWall extends HTMLElement {
        connectedCallback() {
          this.classList.add('qn-vw--js');

          // The click listener survives a DOM move, so it is wired once behind the flag.
          if (!this._wired) {
            this._wired = true;
            this.addEventListener('click', this._onClick.bind(this));
          }

          // The observer does NOT survive: disconnectedCallback drops it when the theme
          // editor re-injects the section, so reveal is re-run on every connect. Guarding
          // this behind _wired would leave motion:full tiles stuck at opacity 0 forever.
          this._reveal();
        }

        disconnectedCallback() {
          this._stopAll(null);
          if (this._observer) {
            this._observer.disconnect();
            this._observer = null;
          }
        }

        get reducedMotion() {
          return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        }

        _reveal() {
          // idempotent: safe to call on every connectedCallback
          if (this._observer) {
            this._observer.disconnect();
            this._observer = null;
          }

          var tiles = Array.prototype.slice.call(this.querySelectorAll('[data-qn-vw-tile]:not(.is-in)'));
          var animate = this.dataset.motion === 'full' && !this.reducedMotion && 'IntersectionObserver' in window;

          if (!animate) {
            tiles.forEach(function (tile) {
              tile.classList.add('is-in');
            });
            return;
          }

          this._observer = new IntersectionObserver(
            function (entries, observer) {
              entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-in');
                observer.unobserve(entry.target);
              });
            },
            { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
          );

          var observer = this._observer;
          tiles.forEach(function (tile) {
            observer.observe(tile);
          });
        }

        _onClick(event) {
          var tile = event.target.closest('[data-qn-vw-tile]');
          if (!tile || !this.contains(tile)) return;
          if (event.target.closest('a')) return; // handle link keeps its own behaviour
          this._play(tile);
        }

        _play(tile) {
          if (tile.hasAttribute('data-playing')) return;

          var template = tile.querySelector('template[data-qn-vw-media]');
          var stage = tile.querySelector('[data-qn-vw-stage]');
          if (!template || !stage) return;

          if (this.dataset.single === 'true') this._stopAll(tile);

          stage.appendChild(template.content.cloneNode(true));
          tile.setAttribute('data-playing', '');

          var video = stage.querySelector('video');
          if (video) {
            video.setAttribute('playsinline', '');
            var attempt = video.play();
            if (attempt && typeof attempt.catch === 'function') {
              attempt.catch(function () {
                /* the visitor still has native controls */
              });
            }
            video.focus({ preventScroll: true });
          }
        }

        _stopAll(except) {
          var self = this;
          Array.prototype.forEach.call(this.querySelectorAll('[data-playing]'), function (tile) {
            if (tile === except) return;
            self._stop(tile);
          });
        }

        _stop(tile) {
          var stage = tile.querySelector('[data-qn-vw-stage]');
          if (stage) {
            var video = stage.querySelector('video');
            if (video) {
              try {
                video.pause();
              } catch (error) {
                /* nothing to pause */
              }
            }
            while (stage.firstChild) stage.removeChild(stage.firstChild);
          }
          tile.removeAttribute('data-playing');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
